namespace Roodik.Core
{
	export class EventDispatcher<T> implements IEventDispatcher<T> {
		private handlers: { (data?: T): void; }[] = [];

		public on(handler: { (data?: T): void }) : void {
			this.handlers.push(handler);
		}

		public off(handler: { (data?: T): void }) : void {
			this.handlers = this.handlers.filter(h => h !== handler);
		}

		public invoke(data?: T)
		{
			this.handlers.slice(0).forEach(h => h(data));
		}

		public expose() : IEventDispatcher<T> {
			return this;
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Events/EventDispatcher.ts